module.exports = __webpack_public_path__ + "img/joszaki-error.775d482.png";